<template>
  <ion-page>
    <ion-tabs>
      <ion-router-outlet></ion-router-outlet>
      <ion-tab-bar>
        <ion-tab-button tab="tab1" href="/tabs/tab1">
          <ion-icon aria-hidden="true" :icon="mapOutline" />
          <ion-label>{{ $t('tabs.tab1') }}</ion-label>
        </ion-tab-button>

        <ion-tab-button tab="tab2" href="/tabs/tab2">
          <ion-icon aria-hidden="true" :icon="listOutline" />
          <ion-label>{{ $t('tabs.tab2') }}</ion-label>
        </ion-tab-button>
<!--
        <ion-tab-button tab="tab3" href="/tabs/tab3">
          <ion-icon aria-hidden="true" :icon="cameraOutline" />
          <ion-label>{{ $t('tabs.tab3') }}</ion-label>
        </ion-tab-button>
      -->

        <ion-tab-button tab="tab4" href="/tabs/tab4">
          <ion-icon aria-hidden="true" :icon="personOutline" />
          <ion-label>{{ $t('tabs.tab4') }}</ion-label>
        </ion-tab-button>
      </ion-tab-bar>
    </ion-tabs>
  </ion-page>
</template>

<script setup lang="ts">
import { IonTabBar, IonTabButton, IonTabs, IonLabel, IonIcon, IonPage, IonRouterOutlet } from '@ionic/vue'
import { mapOutline, listOutline, cameraOutline, personOutline } from 'ionicons/icons'
</script>
